var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 302,
    viewBox: "0 0 286 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.76 0L63 1.74L2.53001 61.62L1.78001 62.36L0.770005 63.36L-0.00999451 64.13V73.66H163.84L234.83 0H64.76ZM158.73 61.62H19.64L69.72 12.04H206.52L158.74 61.63L158.73 61.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.8 73.6599L12.04 163.54V73.6599H0V192.4L119.92 73.6599H102.81H102.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.99 108.75L113.23 110.49L52.76 170.37L52.01 171.11L51 172.11L50.22 172.88V182.41H214.07L285.05 108.75H114.99ZM208.96 170.37H69.87L119.94 120.78H256.74L208.96 170.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.03 182.41L62.27 272.29V182.41H50.23V301.15L170.15 182.41H153.04H153.03Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_92"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 285.07,
    height: 301.16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b3d847735403f71e6082fa77d736452.svg";
export { ForwardRef as ReactComponent };